export default __webpack_public_path__ + "static/media/thumbnail-rocket.4091bf76.webp";